var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AllConsolidatedContainer',{attrs:{"group":_vm.selectedGroup,"project":_vm.selectedProject,"month":_vm.selectedMonth,"estimated":_vm.estimated,"qtypeParam":_vm.qtypeParam}})}
var staticRenderFns = []

export { render, staticRenderFns }